import React, { useEffect } from 'react';
import { SelfTestResultProps } from '../../../../components/self-test/model/SelfTestResultProps';
import './self-test-result.scss';
import { UrlService } from '../../../../core/services/UrlService';
import { result } from '../data/result';
import { TrackingService } from '../../../../core/services/TrackingService';
// type Props = {
//     // title: string;
//     // content: string;
//     image?: string;
//     onReset: (answer?: string) => any;
// }

const BipolarSelfTestResult: React.FC<SelfTestResultProps> = (props: SelfTestResultProps) => {
    const handleResetClick = (ev: any) => {
        props.onReset();
    }

    const [risk, setRisk] = React.useState<boolean>(false);

    useEffect(() => {
        const r = result(props.answers);
        setRisk(r.risk);
    }, [props.answers])

    const defaultItmQuery = {
        itm_source: `self-tests_risk-${risk ? 'high' : 'low'}`,
        itm_medium: 'srp_button',
        itm_campaign: props.questions.analytics.slug,
    };

    const handleSRPButtonClick = React.useCallback(() => {
        TrackingService.trackSelftest(props.questions.analytics.slug, `srp`, props.questions.analytics.resultText(props.answers));
    }, [props.answers]);
    
    const handleHospitalButtonClick = React.useCallback(() => {
        TrackingService.trackSelftest(props.questions.analytics.slug, `hospital`, props.questions.analytics.resultText(props.answers));
    }, [props.answers]);

    return (
        <div id='result' className="self-test__test-result">
            <div className="self-test__test-result-sizer">
                <div className="self-test__test-result-cover">
                    <img src={UrlService.getLocalImageUrl(`self-test/bipolar-disease/result_${risk ? 'bad' : 'good'}.png`)} alt="" />
                </div>
                <div className="self-test__test-result-content">
                    <div className="self-test__test-result-content-top">
                        <div className="self-test__test-result-content-container">
                            <div className="title">
                                評分機制及結果:
                            </div>
                            <div className="subtitle">
                                {`根據您的回答，您患上躁鬱症機會較${risk ? '高' : '低'}。`}
                            </div>
                            <div className="description">
                                <br></br>
                                {
                                    risk ? (
                                        <>
                                            <span>
                                                雖然每個人都有情緒起伏，可是躁鬱症的情緒變化嚴重影響您的日常生活，
                                                如果病情變得嚴重，甚至可能出現思覺失調的病徵，
                                                例如在狂躁狀態下認為自己有特殊能力，在抑鬱狀態下覺得自己不存在等<sup>1</sup>。
                                            </span>
                                            <br></br>
                                            <br></br>
                                            <span>
                                                透過結合心理和藥物治療，及改善生活習慣，可以幫助您穩定情緒，並減低病徵出現的機會，預防病發<sup>2</sup>。
                                            </span>
                                            <br></br>
                                            <br></br>
                                            <span>
                                                擔心躁鬱症影響您的生活？ 立即網上預約專科醫生，尋求專業協助。
                                            </span>
                                        </>
                                    ) : (
                                        <span>雖然如此，了解自己的精神健康十分重要。您可向醫生查詢，了解躁鬱症及其他精神疾病的徵狀及影響。</span>
                                    )
                                }

                                <br></br>
                            </div>
                            <div className="self-test__test-result-content-container-buttons">
                                <a 
                                    className="self-test__button primary" 
                                    target='_blank' 
                                    onClick={handleSRPButtonClick}
                                    href={TrackingService.getNavigateUrlWithITMQuery('https://www.finddoc.com/doctors/bipolar-disease', defaultItmQuery)} rel="noreferrer"
                                >
                                    預約私家精神科醫生
                                </a>
                                <a 
                                    className="self-test__button primary"
                                    target='_blank' 
                                    onClick={handleHospitalButtonClick}
                                    href={TrackingService.getNavigateUrlWithITMQuery(`/self-test/bipolar-disease/hospital`, defaultItmQuery)} rel="noreferrer"
                                >
                                    預約公立醫院門診
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BipolarSelfTestResult;
